var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandDacia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h121v121H0z",
    fill: "#646B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.706 66h3.03V55h-3.03v11zM58.994 55.594l-4.315 4.458c-.155.17-.238.303-.238.448 0 .145.083.279.238.448l4.315 4.458c.452.46.76.594 1.426.594h14.217v-3.72H61.514L59.66 60.5l1.854-1.78h13.123V55H60.42c-.665 0-.974.133-1.426.594zm-34.35 0c-.453-.46-.762-.594-1.427-.594H9v3.72h13.123l1.855 1.78-1.855 1.78H9V66h14.217c.665 0 .974-.133 1.426-.594l4.315-4.458c.155-.17.238-.303.238-.448 0-.145-.083-.279-.238-.448l-4.315-4.458zm76.698-.343c-.17-.167-.304-.251-.45-.251-.146 0-.28.084-.45.251L89.785 66h5.603l5.469-5.572L106.349 66H112l-10.658-10.749zM42.324 55c-.146 0-.28.084-.45.251L31.216 66h5.602l5.469-5.572L47.78 66h5.651L42.773 55.251c-.17-.167-.304-.251-.45-.251z",
    fill: "#FFFFFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandDacia);
export default __webpack_public_path__ + "static/media/brand_dacia.f306fcd65be55a38298f685264be1354.svg";
export { ForwardRef as ReactComponent };